const IplinkStore = () => import('./../integrations/IplinkStore');

export default {
  name: 'iplink-store',
  path: 'support',
  component: IplinkStore,
  meta: {
    title: 'Integrações',
  },
  props: {
    appListSearch: { visible: true },
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-integrations/features/support/routes.js